/**
 * Match Hub "Table" tab — match-specific mini standings with the two teams highlighted.
 */

import React, { useMemo } from 'react';
import { MatchHubStandingsTable } from './MatchHubStandingsTable';
import type { MatchHubMockData } from '../../../src/match/types/matchHub.types';

export interface MatchHubTablePanelProps {
  data: MatchHubMockData;
}

export const MatchHubTablePanel: React.FC<MatchHubTablePanelProps> = ({ data }) => {
  const highlightTeamIds = useMemo(
    () => new Set([data.home.id, data.away.id]),
    [data.home.id, data.away.id],
  );
  return <MatchHubStandingsTable rows={data.standings} highlightTeamIds={highlightTeamIds} />;
};
